import React, { useCallback, useEffect, useMemo, useState } from "react";
import styles from "./LegalNotice.module.scss";
import cx from "classnames";
import HorizontalMenu from "./Menu/HorizontalMenu";
import Dropdown from "./Menu/Dropdown";
import { useTranslationContext } from "@providers/TranslationProvider";
import Markdown from "@components/Markdown";
import styled from "styled-components";
import { useRouteContext } from "@providers/RouteProvider";
import { useLocomotiveContext } from "@providers/LocomotiveProvider";
import { usePageContext } from "@providers/PageProvider";
import { privacyPage } from "@utils/helper";
import _ from "lodash";

export enum LegalNoticeType {
  PrivacyPolicy = "PrivacyPolicy",
  Cookies = "Cookies",
  BestRateGuaranteed = "BestRateGuaranteed",
}
const COMPONENTS = {
  p: ({ children }: any) => <p className="mb-2">{children}</p>,
  strong: ({ children }: any) => (
    <strong style={{ fontWeight: 405 }}>{children}</strong>
  ),
  ul: ({ children }: any) => <div className={styles.bulletsUl}>{children}</div>,
  li: ({ children }: any) => (
    <div className="flex">
      <div className={cx(styles.bullet)}>{`•`}</div>
      <div className={cx(styles.text)}>{children}</div>
    </div>
  ),
  i: ({ children }: any) => <i>{children}</i>,
};
export default function LegalNotice() {
  const { router } = useRouteContext();
  const { scroll } = useLocomotiveContext();
  const { i18n } = useTranslationContext();
  const { pageData } = usePageContext();
  const legalNotes = privacyPage.formatLegalNotice(pageData);

  const [selectValue, setSelectValue] = useState<LegalNoticeType>(
    LegalNoticeType.PrivacyPolicy
  );
  const onMenuChange = useCallback(
    (opt: any) => {
      setSelectValue(opt?.value);
    },
    [setSelectValue]
  );
  const menuOptions = useMemo(
    () => JSON.parse(i18n.t("LegalNotice.menuOptions")),
    [i18n]
  );

  useEffect(() => {
    if (router?.query?.legalNoticeType) {
      setSelectValue(router?.query?.legalNoticeType);
      if (scroll) {
        // 174 is height of header
        scroll.scrollTo("#legalNoticeContent", { duration: 200, offset: -174 });
      }
    }
  }, [router?.query, scroll]);
  const content = _.get(
    _.find(legalNotes, (item) => item.value === selectValue),
    "content"
  );
  return (
    <div data-scroll-section className={cx(styles.section)}>
      <div id="legalNoticeContent" className={cx(styles.menuWrapper)}>
        <div className={cx(styles.menuDesktop)}>
          <HorizontalMenu
            items={legalNotes}
            value={selectValue}
            onChange={(_value, opt) => onMenuChange(opt)}
          />
        </div>
        <div className={cx(styles.menuMobile)}>
          <Dropdown
            className={styles.hotels}
            itemProps={{ className: styles.label }}
            value={selectValue}
            onChange={(opt: any) => onMenuChange(opt)}
            options={menuOptions}
          />
        </div>
      </div>
      <div className={cx(styles.contentWrapper)}>
        <StyledMarkdown components={COMPONENTS} content={content} />
      </div>
    </div>
  );
}

const StyledMarkdown = styled(Markdown)`
  white-space: pre-wrap;
`;
